 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {ContentState, convertFromRaw,} from 'draft-js'

const splitDraftContent = (content) => {
  const rawContent = JSON.parse(content) 
  const {blocks} = rawContent
  let title = _nullishCoalesce(_optionalChain([blocks, 'access', _ => _[0], 'optionalAccess', _2 => _2.text]), () => ( ''))
  // if the title exceeds 256, repeat it in the body because it probably has entities in it
  if (title.length <= 256) {
    blocks.shift()
  } else {
    title = title.slice(0, 256)
  }
  const contentState =
    blocks.length === 0 ? ContentState.createFromText('') : convertFromRaw(rawContent)
  return {title, contentState}
}

export default splitDraftContent
